import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `SaftIntegration` is an implementation of `AbstractIntegration`
 * for integration with Saft.
 */
export default class SaftIntegration extends AbstractIntegration {
	isBeta() {
		return false;
	}

	getName() {
		return "Saft";
	}

	routeName() {
		return "saft";
	}

	static getType() {
		return "SaftIntegration";
	}
}
